<div class="custom-slider">
  <ngx-slider [(value)]="lowValue" [(highValue)]="highValue" [options]="options" (userChange)="changeEvent($event)" ></ngx-slider>
</div>
